.footer {
    display: flex;
    align-items: center;
    gap: 16px;
    padding-top: 8px;
    /* 12px aligns with the row padding */
    padding-right: 12px;
    padding-left: 12px;
}

.footer-with-list-border {
    border-top: var(--border-hairline);
}
